import React, { useEffect, useState } from 'react';
import { Box, Chip, CircularProgress, IconButton, ImageListItem, ImageListItemBar, Menu, MenuItem, Stack, Typography, Skeleton } from '@mui/material';
import { useParams } from "react-router-dom";
import { db } from '../../lib/firebase';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import { doc, updateDoc, onSnapshot } from "firebase/firestore";
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../lib/auth';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DeleteOutfitConfirmationModal from '../shared/DeleteOutfitConfirmationModal';
import { useTranslation } from 'react-i18next';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import EditOutfit from './EditOutfit';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useUserTags } from '../../hooks/tags';
import ShareIcon from '@mui/icons-material/Share';

export default function ShowOutfit() {
  const { outfitId } = useParams();
  const [url, setUrl] = useState(null);
  const [outfit, setOutfit] = useState(null);
  const [user] = useAuthState(auth)
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { t } = useTranslation();
  const [favorite, setFavorite] = useState(false);
  const [openEditOutfitModal, setOpenEditOutfitModal] = useState(false);
  const [outfitImageFile, setOutfitImageFile] = useState(false);

  const [userTags] = useUserTags(user?.uid);

  const handleOptionsButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseOptionsMenu = () => {
    setAnchorEl(null);
  };

  const handleDeleteButtonClick = () => {
    setOpenDeleteModal(true);
  };

  const handleShareOutfit = () => {
    navigator.share({
      url: `/sharedOutfit/${user.uid}/${outfitId}`,
      title: "My Closet",
      text: "Look at my outfit!",
      files: [outfitImageFile]
    }).catch(err => {
      console.error("Error while sharing", err)
    })
  }

  useEffect(() => {
    const outfitRef = doc(db, 'users', user.uid, 'outfits', outfitId);

    onSnapshot(outfitRef, outfitDoc => {
      setOutfit(outfitDoc.data());
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (outfit == null) return

    const storage = getStorage();
    getDownloadURL(ref(storage, `outfits/${outfit.coverPhoto}_900x1200`)).then((downloadURL) => {
      setUrl(downloadURL);
    })
    setFavorite(outfit.favorite)
  }, [outfit]);

  useEffect(() => {
    if (url == null) return

    const getBlobForFile = async () => {
      const res = await fetch(url);
      const blob = await res.blob();
      const file = new File([blob], "picture.jpg", {type: blob});
      setOutfitImageFile(file)
    }

    getBlobForFile();
  }, [url])

  const handleGoHome = () => {
    navigate("/");
  };


  const handleFavoriteClick = async (outfit) => {
    try {
      await updateDoc(doc(db, 'users', user.uid, 'outfits', outfitId), {
        favorite: !favorite,
      });
      setFavorite(!favorite);
    } catch (error) {
      console.error("Error updating", error)
    }
  }

  console.log('outfitImageFile', outfitImageFile)


  const getOutfitTagsWithName = () => {
    if (userTags == null) return [];

    const outfitTagsIds = outfit.moments

    return userTags.filter((tag) => outfitTagsIds.includes(tag.id))
  }


  if (outfit == null || url == null) {
    return <><CircularProgress /></>
  }

  return (
    <Box>
      <ImageListItem key={url}>
        {url ? (
          <img
            src={`${url}?w=248&fit=crop&auto=format`}
            srcSet={`${url}?w=248&fit=crop&auto=format&dpr=2 2x`}
            alt={'mau'}
            loading="lazy"
            style={{ width: "100%" }}
          />
        ) : (
          <Skeleton variant="rectangular" animation="wave" height={'100%'} />
        )}
        <ImageListItemBar
          sx={{
            background:
              'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
              'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
          }}
          position="top"
          actionIcon={
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100vw' }}>
              <IconButton
                sx={{ color: 'white' }}
                onClick={handleGoHome}
              >
                <ArrowBackIosIcon />
              </IconButton>
              <IconButton
                sx={{ color: 'white' }}
                onClick={handleOptionsButtonClick}
              >
                <MoreHorizIcon />
              </IconButton>
            </Box>
          }
          actionPosition="left"
        />
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleCloseOptionsMenu}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={handleDeleteButtonClick}>{t('delete')}</MenuItem>
        </Menu>
      </ImageListItem>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '0.5rem' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ letterSpacing: 6, mb: 2 }}>
            Tags:
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <IconButton
              sx={{ color: 'black' }}
              onClick={() => handleFavoriteClick(outfit)}
            >
              {favorite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
            </IconButton>
            {outfitImageFile && <IconButton onClick={() => handleShareOutfit()} sx={{ color: 'black' }}>
              <ShareIcon />
            </IconButton> }
            
          </Box>
        </Box>
        <Stack direction="row" spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {getOutfitTagsWithName().map((tag) => (
            <Chip
              label={tag.name} sx={{ mb: 1, mt: 1 }}
              key={tag.id}
            />
          ))}
          <Chip icon={<ModeEditIcon />} sx={{ mb: 1 }} onClick={() => { setOpenEditOutfitModal(true) }} label="Edit" />
        </Stack>
      </Box>

      <DeleteOutfitConfirmationModal setOpen={setOpenDeleteModal}
        open={openDeleteModal} outfit={outfit} outfitId={outfitId} />
      <EditOutfit openEditOutfitModal={openEditOutfitModal} setOpenEditOutfitModal={setOpenEditOutfitModal}
        userTags={userTags} currentOutfitTags={outfit.moments} userId={user.uid} outfitId={outfitId} />

    </Box>
  )
}
